import { render, staticRenderFns } from "./MenuHubMobile.vue?vue&type=template&id=196797dd&scoped=true&"
import script from "./MenuHubMobile.vue?vue&type=script&lang=js&"
export * from "./MenuHubMobile.vue?vue&type=script&lang=js&"
import style0 from "./MenuHubMobile.vue?vue&type=style&index=0&id=196797dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196797dd",
  null
  
)

export default component.exports